export default ($) => {
  
  $(() => {
    const $window = $(window)

    $('.js-toggle').on('click', function () {
      $(this).toggleClass('is-active')
      $('#' + $(this).attr('aria-controls')).toggleClass('is-active')
    })

    $('.js-openSideNavi').on('click', function () {
      $('#' + $(this).attr('aria-controls')).addClass('is-active')
    })
    $('.js-closeSideNavi').on('click', function () {
      $(this).closest('.section--sideNavi').removeClass('is-active')
    })

    if ($('.center-item').length) {
      $('.center-item').slick({
        lazyLoad: 'ondemand',
        infinite: true,
        dots: false,
        slidesToShow: 2,
        slidesToScroll: 2,
        centerMode: true,
        centerPadding:'158px',
        autoplay:true,
        autoplaySpeed: 8000,
        arrows: true,
        variableWidth: true
      });
    }
    if ($('.story-slider').length) {
      $('.story-slider').slick({
        lazyLoad: 'ondemand',
        infinite: true,
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipeToSlide: true,
        autoplay: true,
        arrows: true,
        variableWidth: true,
        responsive: [{
          breakpoint: 640,
          settings: "unslick"
        }]
      });
    }
    if ($('.slider').length) {
      $('.slider').slick({
        lazyLoad: 'ondemand',
        autoplay: true,
        autoplaySpeed: 5000,
        dots: true,
        arrows: true
      });
    }

    /*トップページスマホ版の記事切り替え関連*/
    const $tabs = $('.spArticleChangerBtnListItem');
    const $tabsTargets = $tabs.map((_index, tab) => $(`#${$(tab).attr("aria-controls")}`));
    $tabs.on("click" , function() {
      const $currentTab = $(this);
      $tabs.attr('aria-selected', "false");
      $currentTab.attr('aria-selected', "true");
      $tabsTargets.each((_index, target) => {
        const $target = $(target);
        if ($target.attr("id") === $currentTab.attr("aria-controls")) {
          $target.addClass('spTopShow');
        } else {
          $target.removeClass('spTopShow');
        }
      });
      window.smoothScroll("#changeArticleTop", true);
    });

    /**記事切り替えボタンの固定**/
    
    var body = $("body");
    var sectionAttention = $(".section--attention");

    if (sectionAttention.length) {
      $(window).scroll(function() {
        var scroll = $(window).scrollTop() + 60;
        var sectionAttentionOffset = sectionAttention.offset().top + sectionAttention.outerHeight();

        if (scroll >= sectionAttentionOffset) {
          body.addClass("spTopFix");
        } else {
          body.removeClass("spTopFix");
        }
      });
    }

    /**SPメニュー内アコーディオン**/
    $('.toggleBtnDl dt').on('click', function() {
      // クリックされたdt要素の親要素であるtoggleBtnDlにclass "spOpen" を切り替える
      $(this).parent('.toggleBtnDl').toggleClass('spOpen');
    });

    /* 目次のアコーディオン */
    if ($(".is-toggleIndex > .index").length) {
      var $index = $(".article__body > .index");
      var $ul = $index.children("ul");
      var $li = $ul.children("li");
      if ($li.length > 5) {
        $index.addClass("is-hide");
        $index.append('<div class="openButtonArea"><button class="index__openButton"></button><span class="indexButtonText">続きを見る</span></div>');
        var $openButton = $index.find(".index__openButton");
        var $openButtonArea = $index.find(".openButtonArea");
        var $indexButtonText = $openButtonArea.find(".indexButtonText");
        console.log($openButton);
        console.log($openButtonArea);
        $openButtonArea.on("click", function () {
          $index.toggleClass("is-hide");
          $indexButtonText.text(function (i, text) {
            return text === "続きを見る" ? "一部を表示" : "続きを見る";
          });
        });
      }
    }

    /**
     * -------------------------------------
     * スポット情報 API
     * るるぶID API
     * 閲覧履歴
     * プレゼント応募
     * -------------------------------------
     */
    const IS_STG_MODE = location.host !== 'kids.rurubu.jp';
    const JTI_API_APPID = 'eiUd5Qc05pj6y6eB';
    const JTI_API_URL = 'https://www.j-jti.com/appif/sight';
    const JTI_IMAGE_URL = 'https://www.j-jti.com/Storage/Image/Product/SightImage/';
    const RURUBU_ID_FRONT_BASE_URL = IS_STG_MODE ? 'https://member-test.rurubu.jp' : 'https://member.rurubu.jp';
    const RURUBU_KIDS_URL = location.protocol + '//' + location.hostname;
    const RURUBU_ID_LOGIN_URL = RURUBU_ID_FRONT_BASE_URL + '/oauth/authorize';
    const RURUBU_ID_CLIENT_ID = IS_STG_MODE ? '14' : '15';
    const RURUBU_ID_LOGIN_STATUS_URL = RURUBU_ID_FRONT_BASE_URL + '/member/api/login';
    const HISTORY_POSTS_URL = '/wp-json/history/v1/posts';
    let sightIds = [];
    let isBaseLogin = false;
    let rurubuIdInfo = {
      id: '',
      name: '',
      profile_img: '',
      regist_service: '',
      signup: ''
    };
    let isLogin = localStorage.getItem('isLogin') ? true : false;

    /**
     * landingpage_article_* の確定（初回のみ）＋ dataLayer push
     * - 訪問開始（タブ）で1回だけ確定し、以降は上書きしない
     * - PHPが動かないHTMLキャッシュ配信でも成立する
     */
    function pushLandingpageArticleInfo() {
      try {
        window.dataLayer = window.dataLayer || [];
        
        // 複数のキーの最新値を一度に取得
        function getLatestValues(keys) {
          const result = {};
          const keysToFind = new Set(keys);
          
          for (let i = window.dataLayer.length - 1; i >= 0; i--) {
            const item = window.dataLayer[i];
            if (!item) continue;
            
            for (const key of keysToFind) {
              if (item[key] !== undefined) {
                result[key] = item[key];
                keysToFind.delete(key);
              }
            }
            
            if (keysToFind.size === 0) break;
          }
          
          keys.forEach(key => {
            if (result[key] === undefined) result[key] = '';
          });
          
          return result;
        }

        const ss = window.sessionStorage;
        const PREFIX = 'rurubu_kids_';  // プレフィックス定数
        const already = ss.getItem(PREFIX + 'lp_fixed') === '1';

        if (!already) {
          const articleData = getLatestValues([
            'article_area',
            'article_category',
            'article_tag'
          ]);
          
          ss.setItem(PREFIX + 'lp_fixed', '1');
          ss.setItem(PREFIX + 'landingpage_article_area', String(articleData.article_area));
          ss.setItem(PREFIX + 'landingpage_article_category', String(articleData.article_category));
          ss.setItem(PREFIX + 'landingpage_article_tag', String(articleData.article_tag));
        }

        window.dataLayer.push({
          event: 'landingpage_info_ready',
          landingpage_article_area: ss.getItem(PREFIX + 'landingpage_article_area') || '',
          landingpage_article_category: ss.getItem(PREFIX + 'landingpage_article_category') || '',
          landingpage_article_tag: ss.getItem(PREFIX + 'landingpage_article_tag') || ''
        });

      } catch (e) {
        // noop
      }
    }

    if (location.pathname == '/logout/' && isLogin) {
      location.href = '/';
    }

    /**
     * 実行部
     * - ログイン/dataLayer系は Maps に依存させない（失敗すると止まるため）
     * - Maps は必要なページのみ独立ロード
     */
    pushLandingpageArticleInfo(); // event: landingpage_info_ready をpush

    getRurubuIdInfo()
      .then(setUserInfo)          // event: user_info_ready をpush
      .then(setBrowsingHistory);  // 履歴はUI更新のみ

    // Google Map があるページだけ読み込み（失敗しても他処理に影響させない）
    if ($('.googlemap').length) {
      loadGoogleMapsApi().fail(() => {/* noop */});
    }
    
    $('.js-login').on('click', function () {
      localStorage.setItem('isLogin', 'true');
      const redirectState = $(this).data('state');
      if (isBaseLogin) {
        location.reload();
      } else {
        location.href = `${ RURUBU_ID_LOGIN_URL }?client_id=${ RURUBU_ID_CLIENT_ID }&redirect_uri=${ encodeURIComponent(RURUBU_KIDS_URL + '/login_check') }&response_type=code&state=${ redirectState ? redirectState : encodeURIComponent(location.href) }&scope=`;
      }
    });
    $('.js-logout').on('click', () => {
      logout();
    });
    

    /**
     * Google Map APIを読み込み
     * @return {jQuery.Deffered.Promise}
     */
    function loadGoogleMapsApi () {
      var d = new $.Deferred;
      const GOOGLE_API_KEY = 'AIzaSyDr5gnHccg-_Dy0K8rE-3VCAxnELjIlEd0';
      const script = document.createElement('script');
      script.src = 'https://maps.googleapis.com/maps/api/js?key=' + GOOGLE_API_KEY + '&callback=initMap';
      script.defer = true;
      script.async = true;
      window.initMap = () => {
        const googleMapWrapperElements = [].slice.call(document.querySelectorAll('.googlemap'));
        googleMapWrapperElements.forEach(googleMapWrapperElement => {
          var spotLatLng = {
            lat: Number(googleMapWrapperElement.dataset.lat),
            lng: Number(googleMapWrapperElement.dataset.lng)
          }
          var map = new google.maps.Map(googleMapWrapperElement, {
            center: spotLatLng,
            zoom: 12
          });
          var marker = new google.maps.Marker({
            position: spotLatLng,
            map: map,
            title: googleMapWrapperElement.dataset.title
          });
        });
        d.resolve();
      };
      document.head.appendChild(script);
      return d.promise();
    }

    /**
     * るるぶIDのログイン情報を設定
     * @return {jQuery.Deffered.Promise}
     */
    function getRurubuIdInfo () {
      var d = new $.Deferred;
      $.ajax(RURUBU_ID_LOGIN_STATUS_URL, {
        dataType: 'json',
        xhrFields: {
          withCredentials: true
        }
      })
        .done(data => {
          if (!data.error && data.code == 200) {
            isBaseLogin = data.login ? true : false;
            if (isBaseLogin) {
              rurubuIdInfo.id = String(data.id);
              rurubuIdInfo.name = data.name;
              rurubuIdInfo.profile_img = data.profile_img;
              rurubuIdInfo.regist_service = data.regist_service;
              rurubuIdInfo.signup = data.signup;
            }
          } else {
            console.error('A3007でエラーが発生しました。コード: ' + data.code);
            isBaseLogin = false;
          }
          d.resolve();
        })
        .fail(function (jqXHR, textStatus, errorThrown) {
          console.error(textStatus + ': ' + errorThrown);
          $('.only-isLogin').remove();
          isBaseLogin = false;
          d.resolve(); // 失敗しても先へ進む（未ログイン扱い）
        });
      return d.promise();
    }

    /**
     * ログイン情報の表示を設定
     * @return {jQuery.Deffered.Promise}
     */
    function setUserInfo () {
      var d = new $.Deferred;
      window.dataLayer = window.dataLayer || [];
      if (isBaseLogin && isLogin) {
        window.dataLayer.push( {
          event: 'user_info_ready',
          'uid': rurubuIdInfo.id,
          'is_login': 'true',
          'login_service': rurubuIdInfo.regist_service,
          'signup_service':rurubuIdInfo.signup,
        } );
        $('.js-rurubuIdName').text(rurubuIdInfo.name + 'さん');
        if (String(rurubuIdInfo.profile_img).indexOf('/noimage/') === -1) {
          $('.js-rurubuIdProfileImg').attr('src', RURUBU_ID_FRONT_BASE_URL + rurubuIdInfo.profile_img);
        }
        $('.only-isNotLogin').remove();
        $('.only-isLogin').addClass('is-active');
      } else {
        window.dataLayer.push( {
          event: 'user_info_ready',
          'is_login': 'false',
        } );
        $('.only-isLogin').remove();
      }
      window.dataLayer.push({ event: 'datalayer_ready' });
      d.resolve();
      return d.promise();
    }

    /**
     * るるぶIDのログアウト処理を実行
     */
    function logout () {
      localStorage.removeItem('isLogin');
      location.href = '/logout/';
    }

    /**
     * 閲覧履歴を設定
     * @return {jQuery.Deffered.Promise}
     */
    function setBrowsingHistory () {
      var d = new $.Deferred;
      if (isLogin) {
        let browsingHistory = [];
        document.cookie.split('; ').forEach(function (row) {
          if (row.indexOf('browsingHistory') === 0) {
            try {
              const raw = row.replace(/browsingHistory=/, '');
              try {
                browsingHistory = JSON.parse(raw);
              } catch (e) {
                browsingHistory = JSON.parse(decodeURIComponent(raw));
              }
            } catch (e) {
              browsingHistory = [];
            }
            $.ajax({
              url: HISTORY_POSTS_URL,
              method: 'GET',
              dataType: 'json',
              data: {
                ids: browsingHistory.join(',')
              }
            })
              .done(data => {
                if (data.items.length) {
                  let browsingHistoryItems = '';
                  data.items.forEach(item => {
                    const dataSpot = item.sight_id ? ' data-spot="' + item.sight_id + '"' : '';
                    const dataSpotImageS = (item.thumbnail == '/assets/img/img_no-image.png' && item.sight_id) ? ' data-spot-image-s' : '';
                    const area = item.area ? '<p class="infoTag icon--pin">' + item.area + '</p>' : '';
                    const genre = item.genre ? '<p class="infoTag icon--tag">' + item.genre + '</p>' : '';
                    browsingHistoryItems += `
<li class="browsingHistory__item"${ dataSpot }>
  <a href="${ item.permalink }">
    <figure class="browsingHistory__figure"><img src="${ item.thumbnail }" alt="${ item.title }"${ dataSpotImageS }></figure>
    <div class="browsingHistory__text">
      <h3 class="browsingHistory__title">${ item.title }</h3>
      <div class="topHero__info">
        ${ area }
        ${ genre }
      </div>
    </div>
  </a>
</li>`
                  });
                  $('.browsingHistory__list').html(browsingHistoryItems);
                } else {
                  if ($('.l-browsingHistory').length) {
                    $('.l-browsingHistory').remove();
                  }
                }
                d.resolve();
              })
              .fail(function (jqXHR, textStatus, errorThrown) {
                console.error(textStatus + ': ' + errorThrown);
                d.resolve(); // 失敗しても止めない
              });
          }
        });
        if (!browsingHistory.length) {
          $('.l-browsingHistory').remove();
          d.resolve();
        }
      } else {
        $('.l-browsingHistory').remove();
        d.resolve();
      }
      return d.promise();
    }
    
  })

}